<template>
  <div>
    <b-card>
      <b-table
        responsive="sm"
        :items="items"
        :fields="fields"
      >
        <!-- ✅ Link Status Column -->
        <template #cell(link_status)="data">
          <b-badge :variant="data.item.link_status == 1 ? 'success' : 'danger'">
            {{ data.item.link_status == 1 ? "Active" : "Expired" }}
          </b-badge>
        </template>

        <!-- ✅ Actions Column -->
        <template #cell(actions)="data">
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              variant="success"
              size="sm"
              class="mr-2"
              @click="openUpdateModal(data.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>

            <b-button
              variant="danger"
              size="sm"
              @click="deleteSubCategory(data.item.id)"
            >
              <feather-icon icon="DeleteIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>

    <!-- ✅ Update Modal -->

    <b-modal
      ref="updatemodal"
      v-model="show"
      hide-footer
      title="Update LMS Drive Link"
      @hidden="selectedItem = {}"
    >
      <UpdateLmsdriveLink
        :lms-drivedata="selectedItem"
        @updated="handleUpdateSuccess"
        @close="show = false"
      />
    </b-modal>
  </div>
</template>

<script>
import lmsDriveApi from '@/Api/Modules/lmsDriveLinks'
import {
  BModal, BCard, BTable, BBadge, BButton,
} from 'bootstrap-vue'
import UpdateLmsdriveLink from './UpdateLmsdriveLink.vue'

export default {
  name: 'LmsDriveTable',
  components: {
    BCard,
    BTable,
    BBadge,
    BModal,
    BButton,
    UpdateLmsdriveLink,
  },

  data() {
    return {
      show: false,
      selectedItem: {},
      fields: [
        { key: 'batch', label: 'Batch', sortable: true },
        { key: 'intake', label: 'Intake', sortable: true },
        { key: 'drive_link', label: 'Drive Link', sortable: true },
        { key: 'month', label: 'Month Number', sortable: true },
        { key: 'link_status', label: 'Link Status', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
      items: [],
    }
  },

  async created() {
    await this.allDriveLink()
  },

  methods: {
    async allDriveLink() {
      this.$vs.loading({ scale: 0.8 })
      try {
        const res = await lmsDriveApi.allDriveLink()
        this.items = res.data.data
      } catch (error) {
        console.error('Error loading links:', error)
      } finally {
        this.$vs.loading.close()
      }
    },

    async deleteSubCategory(id) {
      this.$vs.loading({ scale: 0.8 })
      try {
        await lmsDriveApi.deleteDriveLink(id)
        this.$vs.loading.close()

        await this.allDriveLink() // ✅ Reload data
      } catch (error) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to delete drive link.',
          color: 'danger',
        })
      }
    },

    openUpdateModal(item) {
      this.selectedItem = { ...item }
      this.show = true
    },

    handleUpdateSuccess() {
      this.show = false
      this.allDriveLink() // ✅ Refreshes table after update
    },
  },
}
</script>

<style>
/* Optional styling */
.d-flex button {
  min-width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
